import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

function EnterYourCar() {
  const { userInfo } = useSelector((state) => state.userLogin);

  return (
    <section className="enter-band">
      <div className="site-wrap">
        <h2>Enter Your Car</h2>
        <div className="enter-steps">
          <article className="enter-step">
            <svg viewBox="0 0 320 210" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
              <rect width="320" height="210" fill="#f3c98a" />
              <circle cx="78" cy="36" r="20" fill="#c4553a" />
              <rect x="56" y="60" width="44" height="30" rx="8" fill="#1c3d4a" />
              <rect x="122" y="28" width="156" height="58" rx="12" fill="#fffaf4" />
              <rect x="140" y="46" width="78" height="8" rx="4" fill="#1c3d4a" />
              <rect x="140" y="62" width="50" height="8" rx="4" fill="#d7c7ae" />
            </svg>
            <div className="enter-step-copy">
              <p className="enter-step-label">Step 1</p>
              <h3>Sign in</h3>
              <p>Open an account so the field knows who is bringing the car.</p>
            </div>
          </article>
          <article className="enter-step">
            <svg viewBox="0 0 320 210" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
              <rect width="320" height="210" fill="#e7d3ad" />
              <g transform="translate(0 -6)">
                <path d="M46 58 L160 18 L274 58 Z" fill="#1c3d4a" />
                <rect x="62" y="56" width="196" height="52" fill="#1c3d4a" />
                <rect x="78" y="66" width="22" height="14" rx="2" fill="#8ec4d4" />
                <rect x="220" y="66" width="22" height="14" rx="2" fill="#8ec4d4" />
                <rect x="112" y="64" width="96" height="44" rx="3" fill="#24343c" />
                <rect x="100" y="74" width="120" height="26" rx="10" fill="#c4553a" />
                <circle cx="128" cy="100" r="11" fill="#2b2b2b" />
                <circle cx="192" cy="100" r="11" fill="#2b2b2b" />
              </g>
            </svg>
            <div className="enter-step-copy">
              <p className="enter-step-label">Step 2</p>
              <h3>Add a car to your garage</h3>
              <p>Save the year, the make, and a photo. It stays ready for the next lawn.</p>
            </div>
          </article>
          <article className="enter-step">
            <svg viewBox="0 0 320 210" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
              <rect width="320" height="210" fill="#8ec4d4" />
              <rect y="88" width="320" height="122" fill="#d9c29a" />
              <rect x="36" y="52" width="136" height="40" rx="16" fill="#f7f1e6" />
              <circle cx="68" cy="92" r="13" fill="#2b2b2b" />
              <circle cx="142" cy="92" r="13" fill="#2b2b2b" />
              <path d="M190 100 C214 42 280 34 310 78 L314 100 Z" fill="#1f6578" />
            </svg>
            <div className="enter-step-copy">
              <p className="enter-step-label">Step 3</p>
              <h3>Enter your car into the show</h3>
              <p>Pick a class and bring that car out to the field.</p>
            </div>
          </article>
        </div>
        <Link className="btn btn-site" to={userInfo ? "/profile?section=garage" : "/login"}>
          Add a car to your garage
        </Link>
      </div>
    </section>
  );
}

export default EnterYourCar;
